import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["children", "itemsBeforeTruncate", "itemsAfterTruncate"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Breadcrumb/Breadcrumb.js",
    _this = this;
/* stylelint-disable */


import React from 'react';
import styled from 'styled-components';
import BreadcrumbItem, { BreadcrumbText } from './BreadcrumbItem';
import { testIdProps } from '../../helpers';
import theme from '../../theme';

var renderChildren = function renderChildren(children, itemsBeforeTruncate, itemsAfterTruncate) {
  var allItems = React.Children.toArray(children);

  if (itemsBeforeTruncate + itemsAfterTruncate >= allItems.length) {
    return allItems;
  }

  var beforeItems = allItems.slice(0, itemsBeforeTruncate);
  var afterItems = allItems.slice(allItems.length - itemsAfterTruncate, allItems.length);
  return [].concat(_toConsumableArray(beforeItems), [/*#__PURE__*/React.createElement(BreadcrumbItem, {
    key: "ellipsis",
    className: "ellipsis",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 5
    }
  }, "...")], _toConsumableArray(afterItems));
};

var StyledBreadcrumb = styled.div.withConfig({
  displayName: "Breadcrumb__StyledBreadcrumb",
  componentId: "sc-l8ccot-0"
})(["", "{color:", ";}> :last-child{", "{font-weight:bold;color:", ";}.separator{display:none;}}> :not(:last-child):not(.ellipsis){", "{:hover{color:", ";cursor:pointer;text-decoration:none;}}}"], BreadcrumbText, theme.main.colours.tertiary.l3, BreadcrumbText, theme.main.colours.tertiary.base, BreadcrumbText, theme.main.colours.tertiary.base);

var Breadcrumb = function Breadcrumb(_ref) {
  var children = _ref.children,
      itemsBeforeTruncate = _ref.itemsBeforeTruncate,
      itemsAfterTruncate = _ref.itemsAfterTruncate,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledBreadcrumb, _extends({}, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 5
    }
  }), renderChildren(children, itemsBeforeTruncate, itemsAfterTruncate));
};

Breadcrumb.defaultProps = {
  itemsBeforeTruncate: 1,
  itemsAfterTruncate: 3
};
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;